import { createSlice, PayloadAction, PrepareAction } from '@reduxjs/toolkit'

interface Release {
  releaseid: string | number
  [key: string]: unknown
}

interface ArchivedState {
  page: number
  totalItemsCount: number | null
  sort: string | null
  loading: boolean
  releases: Release[]
}

const initialState: ArchivedState = {
  page: 0,
  totalItemsCount: null,
  sort: null,
  loading: false,
  releases: [],
}

const archivedSlice = createSlice({
  name: 'archived',
  initialState,
  reducers: {
    restoreAllStart: (state) => {
      state.loading = true
    },
    restoreAllSuccess: () => initialState,
    restoreAllError: (state) => {
      state.loading = false
    },
    loadingArchivedStart: (state) => {
      state.loading = true
    },
    loadingArchivedSuccess: {
      prepare(releases: Release[], page: number, totalItemsCount: number) {
        return { payload: { releases, page, totalItemsCount } }
      },
      reducer(state, action: PayloadAction<{ releases: Release[]; page: number; totalItemsCount: number }>) {
        const { releases, page, totalItemsCount } = action.payload
        const newReleases = state.releases.concat(releases)
        if (page === state.page + 1) {
          state.releases = newReleases
          state.page = page
          state.totalItemsCount = totalItemsCount
          state.loading = false
        }
      },
    },
    loadingArchivedError: (state) => {
      state.loading = false
    },
    sortArchivedBy: (state, action: PayloadAction<string>) => {
      state.sort = state.sort === action.payload ? null : action.payload
    },
    removeArchivedRelease: (state, action: PayloadAction<Release>) => {
      state.releases = state.releases.filter(
        (item) => item.releaseid !== action.payload.releaseid
      )
    },
    addArchivedRelease: (state, action: PayloadAction<Release>) => {
      state.releases.unshift(action.payload)
    },
    refreshArchived: (state) => {
      state.page = 0
      state.totalItemsCount = null
      state.releases = []
    },
    reset: () => initialState,
  },
})

export const archivedActions = archivedSlice.actions
export const archivedReducer = archivedSlice.reducer
export default archivedActions
